import { Component, ChangeDetectionStrategy } from '@angular/core';
import { SiteStateService } from '@core/services/site-state/site-state.service';
import { transform } from '@shared/animations/animations.functions';
import { NgIf, AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-progress',
    templateUrl: './progress.component.html',
    styleUrls: ['./progress.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [
        transform({
            valueFrom: '0',
            valueTo: '1',
            property: 'scaleY',
            fadeIn: false
        })
    ],
    imports: [NgIf, AsyncPipe]
})
export class ProgressComponent {
    constructor(public siteStateService: SiteStateService) {}
}
